import React, { useState, useRef } from "react";
import "../../../styles/trademodals.scss";
import { t } from "../../../../../utils/i18n";

const AssetsSafetyCheckModal = ({ tradeData, onConfirm, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [checkboxes, setCheckboxes] = useState({
    check1: false,
    check2: false,
    check3: false,
  });

  const errorRef = useRef(null);

  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    setCheckboxes({ ...checkboxes, [id]: checked });
  };

  const handleConfirm = (e) => {
    e.preventDefault();
    if (Object.values(checkboxes).every((checked) => checked)) {
      if (errorRef.current) {
        errorRef.current.style.display = "none";
      }
      setIsLoading(true);
      onConfirm();
    } else {
      if (errorRef.current) {
        errorRef.current.style.display = "block";
      }
    }
  };

  return (
    <div
      className="modal-status-cont"
      tabIndex={-1}
      aria-hidden="true"
      id="releaseConfirmModal"
      aria-labelledby="cancelConfirmModalLabel"
    >
      <div className="modal-status-alert-cont">
        <div>
          <button
            type="button"
            className="close"
            onClick={() => {onClose('releaseConfirmModal')}}
            aria-label={t("p2p.common.close")}
            disabled={isLoading}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <br/>
        </div>
        <div>
          <p className="modal-title" id="assetsSafetyCheckModalLabel">
            {t("p2p.safety.title")}
          </p>
          <div className="trademodal-notice">
            <span>
              {" "}
              {t("p2p.safety.notice")}
            </span>
          </div>
          {/* Checklist Section */}
          <div className="trademodal-form-section">
            <small id="cancelErrorMessage" ref={errorRef} style={{ display: "none", color: "red" }}>
              {t("p2p.cancel_modal.check_all")}
            </small>
            {/* Checklist 1 */}
            <div className="trademodal-form-check">
              <input
                type="checkbox"
                className="trademodal-form-check-input"
                id="check1"
                checked={checkboxes.check1}
                onChange={handleCheckboxChange}
              />
              <label className="trademodal-form-check-label" htmlFor="check1">
                {t("p2p.safety.check1", { amount: tradeData?.fiat, currency: tradeData?.fiat_currency_code })}
              </label>
            </div>
            {/* Checklist 2 */}
            <div className="trademodal-form-check">
              <input
                type="checkbox"
                className="trademodal-form-check-input"
                id="check2"
                checked={checkboxes.check2}
                onChange={handleCheckboxChange}
              />
              <label className="trademodal-form-check-label" htmlFor="check2">
                {t("p2p.safety.check2", { name: tradeData.buyer_username })}
              </label>
            </div>
            {/* Checklist 3 */}
            <div className="trademodal-form-check">
              <input
                type="checkbox"
                className="trademodal-form-check-input"
                id="check3"
                checked={checkboxes.check3}
                onChange={handleCheckboxChange}
              />
              <label className="trademodal-form-check-label" htmlFor="check3">
                {t("p2p.safety.check3", { amount: parseFloat(tradeData?.crypto_amount).toFixed(2) })}
              </label>
            </div>
          </div>
        </div>

        {/* buttons */}
        <div className="modal-buttons-section">
          <div>
            <button
              type="button"
              className="modal-tradeaction-canceltradebtn"
              onClick={() => {onClose('releaseConfirmModal')}}
              disabled={isLoading}
            >
              {t("p2p.common.cancel")}
            </button>
          </div>
          <div>
            <button
              type="button"
              disabled={!Object.values(checkboxes).every(Boolean)}
              className="modal-tradeaction-paidbtn"
              onClick={handleConfirm}
            >
              {isLoading ? t("p2p.common.please_wait") : t("p2p.common.confirm")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetsSafetyCheckModal;
